<template>
  <div id="app">
    <Container />
  </div>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: 'HomeView',
  components: {
    Container
  }
}
</script>
